import { render, staticRenderFns } from "./component-special.vue?vue&type=template&id=64f157d9&scoped=true&"
import script from "./component-special.vue?vue&type=script&lang=js&"
export * from "./component-special.vue?vue&type=script&lang=js&"
import style0 from "./component-special.vue?vue&type=style&index=0&id=64f157d9&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64f157d9",
  null
  
)

export default component.exports